import React from 'react';
import { useSelector } from 'react-redux';
import { WholeState } from '../../../../store/common/type';
import commonResource from '../../../../locales/th/common.json';
import config from '../../../../common/config';
import {
  LoggedOutLinkWrapper,
  UserName,
  UserProfileWrapper,
} from './MobileAccount.style';
import { UserProfileImage } from '../../../../common/assets/UserProfileImage';

import { NavigationMenu } from './NavigationMenu';
import { NavigationDropdown } from './MobileNavigation.style';
import { AccountDropdownItem } from './AccountDropdownItem';

export const MobileAccount: React.FC = () => {
  const isUserLogin = useSelector((state: WholeState) =>
    state.common ? state.common.islogin : false,
  );
  const displayName = useSelector((state: WholeState) =>
    state.common ? state.common.displayName : '',
  );

  return (
    <>
      {isUserLogin ? (
        <NavigationMenu
          label={
            <UserProfileWrapper>
              <UserProfileImage />
              <UserName>{displayName}</UserName>
            </UserProfileWrapper>
          }
          menuDropdown={
            <NavigationDropdown>
              <AccountDropdownItem
                key={commonResource.account.myprofile}
                label={commonResource.account.myprofile}
                link="/profile/"
              />
              <AccountDropdownItem
                key={commonResource.account.logout}
                label={commonResource.account.logout}
                link={config.logoutUrl}
              />
            </NavigationDropdown>
          }
        />
      ) : (
        <LoggedOutLinkWrapper>
          <a href={config.signupUrl} data-test="mobile-signup-link">
            {commonResource.account.signUp}
          </a>
          <a href={config.loginUrl} data-test="mobile-login-link">
            {commonResource.account.login}
          </a>
        </LoggedOutLinkWrapper>
      )}
    </>
  );
};
